import { Text } from '@jfs/ui-new'
import { OtpTextInput } from '../../../comps/OtpTextInput'
import { otp } from '../../../util/validations'
export const otpForm = (value: string, error: string, setFieldValue: any, setSubmitOtpError: any): any => [
  {
    formItems: [
      {
        fieldName: 'otp',
        ComponentName: OtpTextInput,
        validationSchema: otp,
        value: value,
        setFieldValue: (_data: any, val: any) => {
          if (error) {
            setSubmitOtpError('')
          }
          setFieldValue(val)
        },
        testID: 'otpInput',
      },
      {
        fieldName: 'error',
        ComponentName: Text,
        validationSchema: otp,
        value: error,
        color: 'RED',
        FontSize: 10,
        FontWeight: 'bold',
        textAlign: 'center',
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]
